/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from "react";
import styled from "styled-components";
import Colors from "constants/Colors";

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-right:10px;
  margin-left:10px;
`;

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 3px;
`;
// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div`
  display: inline-block;
  border: 1px solid  ${(props) => (props.disabled ? Colors.GRAY[3] : '')};
 
  width: 18px;
  height: 18px;
  background: ${(props) => (props.checked ? Colors.GRAY[6] : Colors.GRAY[5])}
  border-radius: 2px;
  transition: all 150ms;
  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 1px ${Colors.GRAY[6]};
  }
  ${Icon} {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")}
  }
`;

const Checkbox = ({ className, checked, field, ...props }) => {

  return (
    <CheckboxContainer className={className} >
      <HiddenCheckbox disabled={props.disabled || false} checked={checked} {...props} />
      <StyledCheckbox checked={checked} disabled={props.disabled || false} >
        <Icon viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </Icon>
      </StyledCheckbox>
    </CheckboxContainer>
  );
};

export default Checkbox;